import ServiceCard from "../components/ServiceCard";

function Services() {
	const services = [
		{
			title: "ICT Consulting",
			description:
				"Strategic IT advisory services to optimize business processes.",
			icon: "💼",
		},
		{
			title: "IT Infrastructure Installation",
			description: "End-to-end setup of servers, networks, and data centers.",
			icon: "🖥️",
		},
		{
			title: "Power Installation",
			description:
				"Solar, inverter, UPS, and generator installations for businesses.",
			icon: "🔋",
		},
		{
			title: "Civil Works",
			description:
				"Construction of masts, data centers, equipment rooms, and more.",
			icon: "🏗️",
		},
	];

	return (
		<div className="p-8">
			<h2 className="text-4xl font-bold mb-6">Our Services</h2>
			<div className="grid md:grid-cols-2 gap-6">
				{services.map((service, index) => (
					<ServiceCard key={index} {...service} />
				))}
			</div>
		</div>
	);
}

export default Services;
